import type { Loadable } from '@/loadingUtils'
import type { Study } from '@pocketprep/types'

export interface ILicenseModuleState {
    currentOrgLicenses: { [key: string]: Loadable<Study.Class.LicenseJSON[]> | undefined }
}

export const getInitialLicenseState = (): ILicenseModuleState => {
    return {
        currentOrgLicenses: {},
    }
}

const moduleState = getInitialLicenseState()

export default moduleState
